import React from 'react';
import { Helmet } from "react-helmet";
import "./Store.scss";
import StoreLocator from '../components/common/StoreLocator';
import Heading from '../components/common/Heading';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import {Pagination } from 'swiper/modules';
import { useDispatch } from "react-redux";

import useWindowSize from '../hooks/useWindowSize';

//services 
import Experties from '../components/Experties';
import SixColumnlayoutCenter from '../components/SixColumnlayoutCenter';
import { expertiseData } from '../api/expertiseData';

//Benefits
import StarShine from "../assets/images/star_shine.svg";
import Redeem from "../assets/images/redeem.svg";
import Cleaning from "../assets/images/cleaning.svg";
import ScrollAnimatedNumber from '../hooks/ScrollAnimatedNumber';
import ReviewSlider from '../components/ReviewSlider';
import { openSheet } from '../redux/slices/sideSheetSlice';

const storeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    { '@type': 'LocalBusiness', '@id': 'https://www.presstoindia.com/#localbusiness', name: 'Pressto India', url: 'https://www.presstoindia.com/' },
    { '@type': 'ItemList', name: 'Pressto Store Locations', itemListElement: [] },
  ],
};

const HelmetMeta = () => {
  return (
    <Helmet>
      <title>Pressto Store Locator | Find Laundry & Dry Cleaners Near You</title>
      <meta name="description" content="Use the Pressto store locator to find nearby dry cleaning and laundry services. Locate Pressto outlets and services available in your city." />
      <meta name="keywords" content="Pressto Store Locator, Pressto near me, Pressto stores near me, Pressto laundry near me, Pressto dry cleaners near me, Pressto locations"/>
      <link rel="canonical" href="https://www.presstoindia.com/store" />
      <script type="application/ld+json">{JSON.stringify(storeSchema)}</script>
    </Helmet>
  )
};

const items = [
  { img: StarShine, alt: "StarShine", title:"Care that Lasts", lable:"At Pressto, we believe the things you love deserve more time with you. Our garment, shoe, and bag care services focus on restoration, not replacement. From delicate fabrics to well-worn leather, we extend the life of every piece so you can enjoy them for years, not seasons." },
  { img: Redeem, alt: "Redeem", title:"Packaging with Purpose", lable:"Every detail counts - even how your items are returned. Our 100% recyclable and compostable packaging reflects our commitment to reducing waste and embracing circularity, ensuring your clean clothes don’t cost the Earth."},
  { img: Cleaning, alt: "Cleaning" , title:"Cleaning that’s Kinder", lable:"Sustainability isn’t a feature, it’s a foundation. We use advanced technology to minimise water usage, avoid harsh chemicals, and ensure gentle yet effective cleaning. It’s a thoughtful balance of precision and care that protects both your items and the environment."},
];

const Benefits = () => {
  const { width } = useWindowSize();
  return (
    <section className="section-container benefits mb-120">
      <Heading title="When you choose Pressto, you choose…" />
      <div className="you-choose">
        {width > 825 ?
            <div className="grid-container">
            {items.map((item, index) => (
              <div className="grid-item" key={index}>
                <div className="item-image">
                  <img src={item.img} alt={item.alt} width="148" height="148"/>
                </div>
                <div className="details">
                  <h4>{item.title}</h4>
                  <p>{item.lable}</p>
                </div>
              </div>
            ))}
          </div>
        :
          <div className="slider-container autoSlider">

            <Swiper
              slidesPerView={'auto'}
              spaceBetween={28}
              modules={[Pagination]}
              className="slider"
            >
              {items.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="grid-item" key={index}>
                    <div className="item">
                      <div className="item-image">
                        <img src={item.img} alt={item.alt} width="148" height="148"/>
                      </div>
                      <div className="details">
                        <h4>{item.title}</h4>
                        <p>{item.lable}</p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide> 
              ))}                              
            </Swiper>


            
          </div>
        }
      </div>      
    </section>
  );
};

//Short Testimonial
const CustomerReviewHighlight = () => {
  const dispatch = useDispatch();
  const handleOpen = () => {
    //document.body.style.overflow = "hidden";
    dispatch(openSheet());
  };
  return (
    <div className="section-container mb-88">
      <div className="customer-highlight">
        {/* Left */}
        <div className="left lg-hide">
          <p className="count"><ScrollAnimatedNumber value={50000} format={{ notation: 'compact' }} />+</p>
          <p className="label">Happiness Delivered</p>
        </div>

        {/* Center */}
        <div className="centerSlider">
          <ReviewSlider/>
        </div>

        {/* Right */}
        <div className="right lg-hide" onClick={handleOpen} style={{cursor:"pointer"}}>
          <div className="avatars">
            <img src="https://i.pravatar.cc/40?img=1" alt="user" />
            <img src="https://i.pravatar.cc/40?img=2" alt="user" />
            <img src="https://i.pravatar.cc/40?img=3" alt="user" />
            <div className="more">+32</div>
          </div>
          <p className="label">Real Stories, Real Trust</p>
        </div>
      </div>
    </div>
  );
};

const Store = () => {
  return (
    <section className="store">
      <HelmetMeta />
      <section className="section-container mb-120">  
        <h1 className="store-page-title">Pressto Store Locator</h1>
        <div className="section-tab">
          <p>With a legacy built on precision, care, and innovation, Pressto today operates across 55+ locations in 4 major cities. From day one, we’ve led the way in responsible garment care - blending global standards with thoughtful, eco-conscious practices. Because for us, premium isn’t just about how it looks, but how it lasts.</p>          
        </div>
        <StoreLocator/>       
      </section>
      <div className="mb-120">
        <Experties title="Timeless Care, Unmatched Expertise" data={expertiseData} item="4"/>
      </div>
      <SixColumnlayoutCenter image={["service-tshirt.jpg", "service-bag.jpg"]}/>
      <Benefits />
      <CustomerReviewHighlight/>
    </section>
  )
}

export default Store
